export const RU = {
    // Common
    app_name: 'KorSlovo',
    app_subtitle: 'Изучение корейских слов (한국어 단어 학습)',
    loading: 'Загрузка... (로딩 중...)',
    save: 'Сохранить (저장)',
    cancel: 'Отмена (취소)',
    delete: 'Удалить (삭제)',
    edit: 'Редактировать (편집)',
    create: 'Создать (만들기)',
    search: 'Поиск (검색)',
    confirm: 'Подтвердить (확인)',
    back: 'Назад (뒤로)',
    next: 'Далее (다음)',
    previous: 'Назад (이전)',
    close: 'Закрыть (닫기)',
    yes: 'Да (예)',
    no: 'Нет (아니요)',
    error: 'Ошибка (오류)',
    success: 'Успешно (성공)',

    // Auth
    auth_login: 'Войти (로그인)',
    auth_signup: 'Регистрация (회원가입)',
    auth_logout: 'Выйти (로그아웃)',
    auth_email: 'Электронная почта (이메일)',
    auth_password: 'Пароль (비밀번호)',
    auth_password_confirm: 'Подтвердите пароль (비밀번호 확인)',
    auth_name: 'Имя (이름)',
    auth_email_placeholder: 'name@example.com',
    auth_password_placeholder: 'Введите пароль (비밀번호 입력)',
    auth_name_placeholder: 'Введите ваше имя (이름 입력)',
    auth_login_title: 'Вход в KorSlovo (로그인)',
    auth_login_subtitle: 'Введите данные для входа (로그인 정보를 입력하세요)',
    auth_signup_title: 'Регистрация в KorSlovo (회원가입)',
    auth_signup_subtitle: 'Создайте аккаунт для начала обучения (학습을 시작하려면 계정을 만드세요)',
    auth_no_account: 'Нет аккаунта? (계정이 없으신가요?)',
    auth_has_account: 'Уже есть аккаунт? (이미 계정이 있으신가요?)',
    auth_level_select: 'Выберите уровень (레벨 선택)',
    auth_level_beginner: 'Начинающий (초급)',
    auth_level_elementary: 'Элементарный (초중급)',
    auth_error_email: 'Введите электронную почту',
    auth_error_password: 'Введите пароль',
    auth_error_name: 'Введите имя',
    auth_error_password_match: 'Пароли не совпадают',
    auth_error_invalid: 'Неверная почта или пароль',
    auth_error_password_short: 'Пароль должен быть не менее 6 символов (비밀번호는 6자 이상)',
    auth_password_hint: 'Минимум 6 символов (최소 6자)',
    auth_copyright: '© 2026 KorSlovo. Все права защищены.',
    auth_level_beginner_desc: 'Я только начинаю (처음 시작해요)',
    auth_level_elementary_desc: 'Знаю основы (기초를 알아요)',

    // Navigation
    nav_dashboard: 'Главная (홈)',
    nav_categories: 'Обучение (학습)',
    nav_game: 'Игра (게임)',
    nav_review: 'Повторение (복습)',
    nav_mypage: 'Профиль (프로필)',
    nav_admin: 'Управление (관리)',

    // Dashboard
    dash_title: 'Главная (홈)',
    dash_welcome: 'Добро пожаловать (환영합니다)',
    dash_streak: 'Серия дней (연속 학습)',
    dash_streak_days: 'дн. (일)',
    dash_words_learned: 'Уроков пройдено (완료 레슨)',
    dash_accuracy: 'Точность (정답률)',
    dash_continue: 'Продолжить обучение (학습 계속하기)',
    dash_review_count: 'Слов на повторение (복습할 단어)',
    dash_start_review: 'Начать повторение (복습 시작)',
    dash_recent_lessons: 'Недавние уроки (최근 레슨)',
    dash_no_progress: 'Начните первый урок! (첫 레슨을 시작하세요!)',
    dash_today_summary: 'Сегодня (오늘)',

    // Category
    cat_title: 'Обучение (학습)',
    cat_lessons: 'уроков (레슨)',
    cat_progress: 'прогресс (진도)',

    // Lesson
    lesson_title: 'Уроки (레슨)',
    lesson_words: 'слов (단어)',
    lesson_not_started: 'Не начат (미시작)',
    lesson_in_progress: 'В процессе (학습 중)',
    lesson_completed: 'Завершён (완료)',
    lesson_start: 'Начать урок (레슨 시작)',
    lesson_continue: 'Продолжить (계속하기)',

    // Learn — Steps
    learn_title: 'Изучение (학습)',
    learn_listen: 'Прослушать (듣기)',
    learn_correct: 'Правильно! (정답!)',
    learn_incorrect: 'Неправильно (오답)',

    // Step 1: Preview
    learn_step_preview: 'Предварительный просмотр (미리보기)',
    learn_preview_desc: 'Ознакомьтесь со словами урока (레슨의 단어를 살펴보세요)',
    learn_start_study: 'Начать изучение (학습 시작)',
    learn_words_count: 'слов (단어)',

    // Step 2: Flashcard
    learn_step_flashcard: 'Карточки (낱말카드)',
    learn_flashcard_prompt: 'Напишите перевод на русский (러시아어 뜻을 입력하세요)',
    learn_flashcard_prompt_reverse: 'Напишите слово по-корейски (한국어 단어를 입력하세요)',
    learn_flashcard_placeholder: 'Перевод (뜻)',
    learn_flashcard_placeholder_reverse: '한국어 (корейское слово)',
    learn_direction_label: 'Режим карточек (플래시카드 모드)',
    learn_direction_ko2ru: '한국어 → Русский',
    learn_direction_ru2ko: 'Русский → 한국어',
    learn_direction_both: 'Оба направления (양방향)',
    learn_flashcard_submit: 'Проверить (확인)',
    learn_flashcard_correct: 'Правильно! (정답!)',
    learn_flashcard_wrong: 'Неправильно (오답)',
    learn_flashcard_answer_was: 'Правильный ответ (정답)',
    learn_flashcard_retry: 'Повтор (재시도)',
    learn_flashcard_verify: 'Финальная проверка (최종 확인)',
    learn_flashcard_mastered: 'Запомнили (외운 단어)',
    learn_show_answer: 'Показать ответ (정답 보기)',
    learn_know: 'Знаю (알아요)',
    learn_dont_know: 'Не знаю (몰라요)',
    learn_remaining: 'Осталось (남은 단어)',
    learn_round: 'Раунд (라운드)',
    learn_all_memorized: 'Все слова запомнены! (모든 단어를 외웠어요!)',
    learn_go_matching: 'Перейти к тесту (뜻 맞추기로)',

    // Step 3: Matching
    learn_step_matching: 'Подбор значений (뜻 맞추기)',
    learn_match_prompt: 'Выберите правильный перевод (올바른 뜻을 고르세요)',
    learn_match_score: 'Счёт (점수)',

    // Step 4: Result
    learn_step_result: 'Результат (결과)',
    learn_result_great: 'Отлично! (훌륭해요!)',
    learn_result_good: 'Хорошо! (잘했어요!)',
    learn_result_retry: 'Попробуйте ещё! (다시 도전하세요!)',
    learn_flashcard_result: 'Карточки (낱말카드)',
    learn_matching_result: 'Подбор значений (뜻 맞추기)',
    learn_known_count: 'Знал(а) (알고 있었던 단어)',
    learn_unknown_count: 'Не знал(а) (모르던 단어)',
    learn_retry: 'Повторить урок (다시 학습)',
    learn_start_quiz: 'Начать тест (퀴즈 시작)',
    learn_complete: 'Обучение завершено! (학습 완료!)',

    // Quiz
    quiz_title: 'Тест (퀴즈)',
    quiz_choice: 'Выбор (객관식)',
    quiz_listening: 'Аудирование (듣기)',
    quiz_speaking: 'Произношение (말하기)',
    quiz_question: 'Вопрос (문제)',
    quiz_of: 'из',
    quiz_select_answer: 'Выберите правильный ответ (정답을 선택하세요)',
    quiz_listen_select: 'Прослушайте и выберите слово (듣고 단어를 선택하세요)',
    quiz_speak_word: 'Произнесите это слово (이 단어를 말하세요)',
    quiz_replay: 'Повторить (다시 듣기)',
    learn_speak: 'Произнести (말하기)',
    learn_speak_now: 'Слушаю... (듣고 있어요...)',
    learn_mic_unsupported: 'Ваш браузер не поддерживает распознавание речи (브라우저가 음성인식을 지원하지 않습니다)',
    quiz_correct: 'Правильно! (정답!)',
    quiz_wrong: 'Неправильно (오답)',
    quiz_partial: 'Почти правильно! Попробуйте точнее (거의 맞았어요! 더 정확하게 말해보세요)',
    quiz_next: 'Следующий вопрос (다음 문제)',

    // Quiz Result
    result_title: 'Результат (결과)',
    result_score: 'Баллы (점수)',
    result_correct: 'Правильных (정답)',
    result_wrong: 'Неправильных (오답)',
    result_accuracy: 'Точность (정답률)',
    result_review: 'Повторить ошибки (오답 복습)',
    result_retry: 'Пройти снова (다시 도전)',
    result_next_lesson: 'Следующий урок (다음 레슨)',
    result_wrong_words: 'Неправильные слова (틀린 단어)',
    result_your_answer: 'Ваш ответ (내 답)',

    // Review
    review_title: 'Повторение (복습)',
    review_no_words: 'Нет слов для повторения (복습할 단어가 없습니다)',
    review_words_count: 'слов для повторения (복습할 단어)',
    review_mastered: 'Освоено! (완벽히 외웠어요!)',
    review_start: 'Начать повторение (복습 시작)',
    review_tap_to_flip: 'Нажмите для перевода (터치하여 뒤집기)',
    review_swipe_hint: '← Свайп для следующей (다음 카드로 스와이프)',
    review_due_now: 'Готовы к повторению (복습 준비됨)',
    review_upcoming: 'Ожидают повторения (복습 예정)',
    review_mastered_count: 'Освоено слов (완료된 단어)',
    review_no_due: 'Все повторения выполнены! (오늘 복습 완료!)',
    review_next_check: 'Новые слова появятся позже (새 단어가 곧 나타납니다)',
    review_level: 'Уровень (레벨)',
    review_promoted: 'Следующий этап! (다음 단계!)',
    review_batch_info: 'из {total} слов (전체 {total}개 중)',
    review_batch_remaining: 'Ещё {n} слов для повторения (복습할 단어 {n}개 남음)',

    // My Page
    mypage_title: 'Профиль (프로필)',
    mypage_stats: 'Статистика (통계)',
    mypage_total_words: 'Всего слов (전체 단어)',
    mypage_avg_accuracy: 'Средняя точность (평균 정답률)',
    mypage_streak: 'Серия дней (연속 학습)',
    mypage_lessons_progress: 'Прогресс уроков (레슨 진도)',
    mypage_change_password: 'Изменить пароль (비밀번호 변경)',
    mypage_current_password: 'Текущий пароль (현재 비밀번호)',
    mypage_new_password: 'Новый пароль (새 비밀번호)',
    mypage_level: 'Уровень (레벨)',
    mypage_min_password: 'Минимум 4 символа (최소 4자)',

    // Admin — Navigation & Page Titles
    admin_dashboard: 'Панель управления',
    admin_categories: 'Категории',
    admin_lessons: 'Уроки',
    admin_words: 'Слова',
    admin_users: 'Пользователи',
    admin_quality: 'Качество контента',

    // Admin — Dashboard
    admin_stats: 'Статистика',
    admin_total_users: 'Всего пользователей',
    admin_active_today: 'Активных сегодня',
    admin_avg_accuracy: 'Средняя точность',
    admin_popular_category: 'Популярные категории',
    admin_recent_users: 'Новые пользователи',
    admin_total_lessons: 'Уроков',
    admin_no_data: 'Нет данных',

    // Admin — Common UI
    admin_add: 'Добавить',
    admin_save: 'Сохранить',
    admin_cancel: 'Отмена',
    admin_delete: 'Удалить',
    admin_edit: 'Редактировать',
    admin_create: 'Создать',
    admin_saving: 'Сохранение...',
    admin_save_changes: 'Сохранить изменения',
    admin_close: 'Закрыть',
    admin_icon: 'Иконка',
    admin_name_ru: 'Название (рус)',
    admin_name_ko: 'Название (кор)',
    admin_description: 'Описание',
    admin_description_short: 'Краткое описание',
    admin_sort_order: 'Порядок',
    admin_status: 'Статус',
    admin_status_active: 'Активен',
    admin_status_inactive: 'Неактивен',
    admin_status_active_f: 'Активна',
    admin_status_hidden: 'Скрыта',
    admin_no: '№',
    admin_lessons_count: 'Уроки',
    admin_words_count: 'Слов',
    admin_actions: 'Действия',

    // Admin — Categories
    admin_new_category: 'Новая категория',
    admin_edit_category: 'Редактировать категорию',
    admin_create_first_category: 'Создать первую категорию',
    admin_no_categories: 'Категории пока нет',

    // Admin — Lessons
    admin_new_lesson: 'Новый урок',
    admin_edit_lesson: 'Редактировать урок',
    admin_create_first_lesson: 'Создать первый урок',
    admin_no_lessons: 'В этой категории пока нет уроков',

    // Admin — Words
    admin_new_word: 'Новое слово',
    admin_edit_word: 'Редактировать слово',
    admin_no_words: 'В этом уроке пока нет слов',
    admin_import_csv: 'Импорт CSV',
    admin_export: 'Экспорт',
    admin_conflicts: 'Конфликты',
    admin_bulk_edit: 'Массовое редактирование',
    admin_bulk_close: 'Закрыть',
    admin_auto_descriptions: 'Авто-описания',
    admin_db_migrate: 'DB Migrate',
    admin_korean: 'Корейский',
    admin_pronunciation: 'Произношение',
    admin_russian: 'Русский',
    admin_example_ko: 'Пример (кор)',
    admin_example_ru: 'Пример (рус)',
    admin_accepted_answers: 'Допустимые ответы',
    admin_accepted_hint: 'Подсказка',
    admin_description_ru: 'Описание на русском',
    admin_crossword_desc: 'Описание для кроссворда',
    admin_crossword_desc_hint: 'Описание-загадка на русском. Используется в кроссворде.',
    admin_audio: 'Аудио',
    admin_audio_tts: 'TTS',
    admin_audio_recorded: 'Записано',
    admin_upload_audio: 'Загрузить аудио',
    admin_delete_audio: 'Удалить',
    admin_csv_format: 'кор, произн, русский, пример_кор, пример_рус, доп_ответы(;), подсказка, описание_рус',
    admin_csv_placeholder: 'Вставьте данные CSV сюда...',
    admin_importing: 'Импорт...',
    admin_import: 'Импортировать',
    admin_detected_conflicts: 'Обнаруженные конфликты',
    admin_conflict_warning: 'Конфликт: это слово является ответом в другом задании',

    // Admin — Users
    admin_search_name: 'Поиск по имени...',
    admin_all_roles: 'Все роли',
    admin_role_admin: 'Администратор',
    admin_role_user: 'Пользователь',
    admin_name: 'Имя',
    admin_email: 'E-mail',
    admin_role: 'Роль',
    admin_registered: 'Регистрация',
    admin_no_users: 'Пользователи не найдены',

    // Admin — User Detail
    admin_user_not_found: 'Пользователь не найден',
    admin_tab_overview: 'Обзор',
    admin_tab_profile: 'Профиль',
    admin_tab_xp: 'XP история',
    admin_tab_quizzes: 'Тесты',
    admin_tab_games: 'Игры',
    admin_tab_review: 'Повторение',
    admin_tab_manage: 'Управление',
    admin_xp: 'XP',
    admin_level: 'Уровень',
    admin_last_study: 'Посл. занятие',
    admin_streak: 'Серия',
    admin_total_quizzes: 'Тестов',
    admin_total_games: 'Игр',
    admin_review_words: 'На повт.',
    admin_lesson: 'Урок',
    admin_category: 'Категория',
    admin_score: 'Балл',
    admin_date: 'Дата',
    admin_progress: 'Прогресс',
    admin_completed: 'Завершён',
    admin_in_progress: 'В процессе',
    admin_not_started: 'Не начат',
    admin_no_progress: 'Нет данных о прогрессе',
    admin_no_xp: 'Нет данных о XP',
    admin_no_quizzes: 'Нет данных о тестах',
    admin_no_games: 'Нет данных об играх',
    admin_no_review: 'Нет слов на повторении',
    admin_cleanup_orphans: 'Очистить орфан-записи',
    admin_cleanup_desc: 'Найти и удалить записи прогресса для несуществующих уроков',
    admin_reset_progress: 'Сбросить прогресс',
    admin_reset_desc: 'Удалить весь прогресс обучения пользователя',
    admin_recalc_xp: 'Пересчитать XP',
    admin_recalc_desc: 'Пересчитать XP на основе фактической активности',
    admin_correct: 'Правильных',
    admin_total: 'Всего',
    admin_accuracy: 'Точность',
    admin_time: 'Время',
    admin_type: 'Тип',
    admin_word: 'Слово',
    admin_mastered: 'Освоено',
    admin_next_review: 'Следующее повт.',

    // Admin — Quality
    admin_quality_title: 'Качество контента',
    admin_total_words: 'Все слова',
    admin_with_description: 'С описанием',
    admin_with_audio: 'С аудио',
    admin_with_accepted: 'С доп. ответами',
    admin_coverage: 'Покрытие',
    admin_quality_by_category: 'Качество по категориям',
    admin_missing_fields: 'Отсутствующие данные',
    admin_field: 'Поле',
    admin_filter_all: 'Все',
    admin_title: 'Название',
    admin_lessons_word: 'уроков',
    admin_learners_word: 'учеников',
    admin_create_category_first: 'Сначала создайте категорию',
    admin_go_to_categories: 'Перейти к категориям',
    admin_status_hidden_m: 'Скрыт',
    admin_create_first_word: 'Создать первое слово',
    admin_description_label: 'Описание (рус)',
    admin_placeholder_greeting: 'например: Приветствия',
    admin_placeholder_lesson: 'например: Основные приветствия',
    admin_desc_placeholder_cat: 'Краткое описание категории',
    admin_desc_placeholder_lesson: 'Краткое описание урока',
    admin_back: 'Назад',
    admin_view_detail: 'Подробнее',
    admin_show_missing: 'Показать пропуски',
    admin_hide_missing: 'Скрыть пропуски',
    admin_expand: 'Развернуть',
    admin_collapse: 'Свернуть',
    admin_trend_activity: 'Активность',
    admin_trend_dau: 'Активные пользователи',
    admin_trend_xp: 'Заработано XP',
    admin_trend_quizzes: 'Тестов пройдено',
    admin_trend_games: 'Игры',
    admin_trend_signups: 'Новые регистрации',
    admin_period_7d: '7 дней',
    admin_period_14d: '14 дней',
    admin_period_30d: '30 дней',

    // Admin — additional keys
    admin_no_name: 'Без имени',
    admin_short_level: 'Ур.',
    admin_beginner: 'Новичок',
    admin_until_next: 'До',
    admin_multiplier: 'Множитель',
    admin_modes: 'Режимы',
    admin_updated: 'Обновлено',
    admin_all_types: 'Все типы',
    admin_xp_base: 'Базовый',
    admin_xp_bonus: 'Бонус',
    admin_xp_total: 'Итого',
    admin_result: 'Результат',
    admin_errors: 'Ошибки',
    admin_learning: 'Учим',
    admin_manage_warning: 'Внимание! Эти действия необратимы.',
    admin_check: 'Проверить',
    admin_confirmation: '⚠ Подтверждение',
    admin_confirm_instruction: 'Введите для подтверждения:',
    admin_execute: 'Выполнить',
    admin_listen: '🔊 Слушать',
    admin_detecting: 'Анализ...',
    admin_found: 'Найдено',
    admin_search: 'Поиск',

    // Errors
    error_network: 'Ошибка сети. Проверьте подключение.',
    error_server: 'Ошибка сервера. Попробуйте позже.',
    error_unauthorized: 'Необходима авторизация.',
    error_forbidden: 'Доступ запрещён.',
    error_not_found: 'Не найдено.',

    // Game — Word Search Puzzle
    game_title: 'Поиск слов (단어 찾기)',
    game_select_difficulty: 'Выберите уровень (난이도 선택)',
    game_difficulty_easy: 'Лёгкий (쉬움)',
    game_difficulty_normal: 'Средний (보통)',
    game_difficulty_hard: 'Сложный (어려움)',
    game_difficulty_easy_desc: '8 слов, 10×10',
    game_difficulty_normal_desc: '12 слов, 11×11',
    game_difficulty_hard_desc: '15 слов, 12×12',
    game_find_words: 'Найдите слова в таблице (표에서 단어를 찾으세요)',
    game_found: 'Найдено (찾은 단어)',
    game_time: 'Время (시간)',
    game_tries: 'Попытки (시도)',
    game_complete: 'Все слова найдены! (모든 단어를 찾았어요!)',
    game_retry: 'Ещё раз (다시 하기)',
    game_new: 'Новая игра (새 게임)',
    game_no_words: 'Недостаточно изученных слов (학습 완료 단어가 부족합니다)',
    game_no_words_desc: 'Завершите хотя бы 2 урока для игры (최소 2개 레슨을 완료하세요)',
    game_wrong_try: 'Попробуйте ещё! (다시 시도하세요!)',
    game_bonus_title: 'Бонус! Новые слова (보너스! 새 단어)',
    game_bonus_hint: 'Найдите новые слова в таблице (새 단어도 찾아보세요)',
    game_bonus_skip: 'Пропустить (건너뛰기)',
    game_bonus_found: 'Запомните это слово! (이 단어를 기억하세요!)',
    game_best_time: 'Лучшее время (최고 기록)',
    game_words_label: 'слов (단어)',
    game_hint_drag: 'Проведите по буквам слова (단어 위를 드래그하세요)',

    // Game — XP / Star System
    game_star_rank: 'Ваш ранг (당신의 등급)',
    game_stats_title: 'Игровая статистика (게임 통계)',
    game_play_now: 'Играть (플레이)',
    game_plays_count: 'Игр сыграно (플레이 횟수)',
    game_word_search: 'Поиск слов (단어 찾기)',
    game_crossword: 'Кроссворд (크로스워드)',
    game_recent: 'Недавние игры (최근 기록)',
    game_xp_earned: 'Опыт получен (획득 경험치)',
    game_level_up: '⭐ Новый уровень! (레벨 업!)',
    game_level_up_desc: 'Вы достигли нового звёздного ранга! (새로운 별 등급에 도달했습니다!)',
    game_level_up_ok: 'Отлично! (좋아요!)',
    game_hint_high_repeat: '📚 Слова повторяются! Изучите новый урок, чтобы открыть больше слов. (단어가 반복되고 있어요! 새 레슨을 학습하면 더 많은 단어를 즐길 수 있어요.)',
    game_hint_moderate_repeat: '💡 Новые слова сделают игру интереснее! (새 단어를 배우면 게임이 더 재밌어져요!)',
    game_hint_learn_new: 'Изучить новый урок (새 레슨 학습하기)',

    // XP System
    xp_streak_bonus: 'бонус серии (연속 보너스)',
    xp_breakdown_title: 'Источники опыта (XP 출처)',
    xp_source_lesson: 'Уроки (레슨)',
    xp_source_quiz: 'Тесты (퀴즈)',
    xp_source_review: 'Повторение (복습)',
    xp_source_game: 'Игры (게임)',

    // Review batch
    review_batch_done: 'Повторение завершено! (복습 완료!)',
    review_next_batch: 'Следующая группа (다음 배치)',

    // ё/е 피드백
    fc_yo_hint: 'Обратите внимание на букву ё (ё 글자에 주의하세요)',
    fc_yo_accepted: 'Правильно! (ё → е тоже принимается)',

    // Accepted answers (허용 정답)
    fc_accepted: 'Принято, но есть точнее (맞지만 더 정확한 표현이 있어요)',
    fc_accepted_hint: 'Точнее — {word} ({word}이(가) 더 정확해요)',
    fc_accepted_score: '70 баллов (70점)',
    fc_precision_mode: 'Введите точное слово (정확한 단어를 입력하세요)',
    quiz_accepted: 'Верно, но есть точнее (맞지만 더 정확한 표현이 있어요)',
    quiz_accepted_hint: 'Точнее — {word} ({word}이(가) 더 정확해요)',
    result_accepted_section: 'Слова для уточнения (더 정확히 알아야 할 단어)',
    result_exact_count: 'Точных (정확히 맞춘 단어)',
    result_accepted_count: 'Приблизительных (허용 정답)',
    result_precision: 'Точность (정밀도)',
    result_total_score: 'Итого баллов (총 점수)',

    // Crossword (크로스워드)
    crossword_title: 'Кроссворд (크로스워드)',
    crossword_subtitle: 'Русское описание → корейское слово',
    crossword_across: 'По горизонтали (가로)',
    crossword_down: 'По вертикали (세로)',
    crossword_hint_letter: 'Буква (글자 힌트)',
    crossword_hint_word: 'Слово (단어 힌트)',
    crossword_check: 'Проверить (확인)',
    crossword_complete: 'Кроссворд решён! (크로스워드 완성!)',
    crossword_result: 'Результат (결과)',
    crossword_guessed: 'Угадано (맞춘 단어)',
    crossword_hints_used: 'Подсказки (힌트 사용)',
    crossword_retry: 'Ещё раз (다시 하기)',
    crossword_no_desc: 'Нет уроков с описаниями (설명이 있는 레슨이 없습니다)',
    crossword_no_desc_hint: 'Добавьте описания к словам в админ-панели (관리자 패널에서 단어 설명을 추가하세요)',
    crossword_select_lesson: 'Выберите урок (레슨을 선택하세요)',
    crossword_words_count: 'слов (단어)',
    game_mode_select: 'Выберите режим игры (게임 모드를 선택하세요)',
    hint_label: '💡 Подсказка (힌트)',
    hint_homonym: 'У этого слова несколько значений (이 단어는 여러 의미가 있습니다)',

    // Idle warning (비활동 경고)
    idle_warning_title: 'Вы здесь? (아직 계신가요?)',
    idle_warning_message: 'Вы были неактивны. Через некоторое время вы будете автоматически выведены из системы. (일정 시간 동안 활동이 없어 곧 자동으로 로그아웃됩니다.)',
    idle_continue: 'Продолжить (계속하기)',
    idle_logout: 'Выйти (로그아웃)',
};

/**
 * 러시아어 ё/е 정규화: ё를 е로 변환하여 비교
 * display는 원본 유지, 채점 시에만 사용
 */
export function normalizeYo(text: string): string {
    return text.replace(/ё/g, 'е').replace(/Ё/g, 'Е');
}

export type I18nKey = keyof typeof RU;

/**
 * 관리자 전용 한국어 번역 (admin_ 키만 한국어로 오버라이드)
 * 학습자 페이지는 RU 고정, 관리자만 토글 가능
 */
export const KO: Record<string, string> = {
    // Navigation & Page Titles
    admin_dashboard: '관리 대시보드',
    admin_categories: '카테고리',
    admin_lessons: '레슨',
    admin_words: '단어',
    admin_users: '사용자',
    admin_quality: '콘텐츠 품질',

    // Dashboard
    admin_stats: '통계',
    admin_total_users: '전체 사용자',
    admin_active_today: '오늘 활동',
    admin_avg_accuracy: '평균 정답률',
    admin_popular_category: '인기 카테고리',
    admin_recent_users: '신규 사용자',
    admin_total_lessons: '레슨',
    admin_no_data: '데이터 없음',

    // Common UI
    admin_add: '추가',
    admin_save: '저장',
    admin_cancel: '취소',
    admin_delete: '삭제',
    admin_edit: '편집',
    admin_create: '만들기',
    admin_saving: '저장 중...',
    admin_save_changes: '변경 저장',
    admin_close: '닫기',
    admin_icon: '아이콘',
    admin_name_ru: '이름 (러시아어)',
    admin_name_ko: '이름 (한국어)',
    admin_description: '설명',
    admin_description_short: '간단한 설명',
    admin_sort_order: '순서',
    admin_status: '상태',
    admin_status_active: '활성',
    admin_status_inactive: '비활성',
    admin_status_active_f: '활성',
    admin_status_hidden: '숨김',
    admin_no: '번호',
    admin_lessons_count: '레슨',
    admin_words_count: '단어 수',
    admin_actions: '관리',

    // Categories
    admin_new_category: '새 카테고리',
    admin_edit_category: '카테고리 편집',
    admin_create_first_category: '첫 카테고리 만들기',
    admin_no_categories: '카테고리가 없습니다',

    // Lessons
    admin_new_lesson: '새 레슨',
    admin_edit_lesson: '레슨 편집',
    admin_create_first_lesson: '첫 레슨 만들기',
    admin_no_lessons: '이 카테고리에 레슨이 없습니다',

    // Words
    admin_new_word: '새 단어',
    admin_edit_word: '단어 편집',
    admin_no_words: '이 레슨에 단어가 없습니다',
    admin_import_csv: 'CSV 가져오기',
    admin_export: '내보내기',
    admin_conflicts: '충돌 검사',
    admin_bulk_edit: '일괄 편집',
    admin_bulk_close: '닫기',
    admin_auto_descriptions: '자동 설명 생성',
    admin_db_migrate: 'DB 마이그레이션',
    admin_korean: '한국어',
    admin_pronunciation: '발음',
    admin_russian: '러시아어',
    admin_example_ko: '예문 (한국어)',
    admin_example_ru: '예문 (러시아어)',
    admin_accepted_answers: '허용 정답',
    admin_accepted_hint: '힌트 문구',
    admin_description_ru: '러시아어 설명',
    admin_crossword_desc: '크로스워드용 설명',
    admin_crossword_desc_hint: '러시아어 힌트 설명. 크로스워드에서 사용됩니다.',
    admin_audio: '오디오',
    admin_audio_tts: 'TTS',
    admin_audio_recorded: '녹음됨',
    admin_upload_audio: '오디오 업로드',
    admin_delete_audio: '삭제',
    admin_csv_format: '한국어, 발음, 러시아어, 예문_한, 예문_러, 허용정답(;), 힌트, 설명',
    admin_csv_placeholder: 'CSV 데이터를 붙여넣으세요...',
    admin_importing: '가져오는 중...',
    admin_import: '가져오기',
    admin_detected_conflicts: '발견된 충돌',
    admin_conflict_warning: '충돌: 이 단어는 다른 문제의 정답입니다',

    // Users
    admin_search_name: '이름으로 검색...',
    admin_all_roles: '모든 역할',
    admin_role_admin: '관리자',
    admin_role_user: '사용자',
    admin_name: '이름',
    admin_email: '이메일',
    admin_role: '역할',
    admin_registered: '가입일',
    admin_no_users: '사용자를 찾을 수 없습니다',

    // User Detail
    admin_user_not_found: '사용자를 찾을 수 없습니다',
    admin_tab_overview: '개요',
    admin_tab_profile: '프로필',
    admin_tab_xp: 'XP 이력',
    admin_tab_quizzes: '퀴즈',
    admin_tab_games: '게임',
    admin_tab_review: '복습',
    admin_tab_manage: '관리',
    admin_xp: 'XP',
    admin_level: '레벨',
    admin_last_study: '마지막 학습',
    admin_streak: '연속 학습',
    admin_total_quizzes: '퀴즈 수',
    admin_total_games: '게임 수',
    admin_review_words: '복습 대기',
    admin_lesson: '레슨',
    admin_category: '카테고리',
    admin_score: '점수',
    admin_date: '날짜',
    admin_progress: '진도',
    admin_completed: '완료',
    admin_in_progress: '학습 중',
    admin_not_started: '미시작',
    admin_no_progress: '진도 데이터 없음',
    admin_no_xp: 'XP 데이터 없음',
    admin_no_quizzes: '퀴즈 데이터 없음',
    admin_no_games: '게임 데이터 없음',
    admin_no_review: '복습 대기 단어 없음',
    admin_cleanup_orphans: '고아 데이터 정리',
    admin_cleanup_desc: '존재하지 않는 레슨의 진도 기록 검색 및 삭제',
    admin_reset_progress: '진도 초기화',
    admin_reset_desc: '사용자의 모든 학습 진도 삭제',
    admin_recalc_xp: 'XP 재계산',
    admin_recalc_desc: '실제 활동 기반으로 XP 재계산',
    admin_correct: '정답',
    admin_total: '전체',
    admin_accuracy: '정답률',
    admin_time: '시간',
    admin_type: '유형',
    admin_word: '단어',
    admin_mastered: '완료',
    admin_next_review: '다음 복습',

    // Additional keys
    admin_no_name: '이름 없음',
    admin_short_level: 'Lv.',
    admin_beginner: '초보자',
    admin_until_next: '다음까지',
    admin_multiplier: '배율',
    admin_modes: '모드',
    admin_updated: '수정일',
    admin_all_types: '전체 유형',
    admin_xp_base: '기본',
    admin_xp_bonus: '보너스',
    admin_xp_total: '합계',
    admin_result: '결과',
    admin_errors: '오류',
    admin_learning: '학습 중',
    admin_manage_warning: '주의! 이 작업은 되돌릴 수 없습니다.',
    admin_check: '검사',
    admin_confirmation: '⚠ 확인',
    admin_confirm_instruction: '확인을 위해 입력하세요:',
    admin_execute: '실행',
    admin_listen: '🔊 듣기',
    admin_detecting: '분석 중...',
    admin_found: '발견',
    admin_search: '검색',

    // Quality
    admin_quality_title: '콘텐츠 품질',
    admin_total_words: '전체 단어',
    admin_with_description: '설명 포함',
    admin_with_audio: '오디오 포함',
    admin_with_accepted: '추가 정답 포함',
    admin_coverage: '커버리지',
    admin_quality_by_category: '카테고리별 품질',
    admin_missing_fields: '누락 데이터',
    admin_field: '필드',
    admin_filter_all: '전체',
    admin_title: '제목',
    admin_lessons_word: '레슨',
    admin_learners_word: '학습자',
    admin_create_category_first: '먼저 카테고리를 만드세요',
    admin_go_to_categories: '카테고리로 이동',
    admin_status_hidden_m: '숨김',
    admin_create_first_word: '첫 단어 만들기',
    admin_description_label: '설명 (러시아어)',
    admin_placeholder_greeting: '예: 인사',
    admin_placeholder_lesson: '예: 기본 인사',
    admin_trend_activity: '활동 추이',
    admin_trend_dau: '일일 활성 사용자',
    admin_trend_xp: '획득 XP',
    admin_trend_quizzes: '퀴즈 완료 수',
    admin_trend_games: '게임 활동',
    admin_trend_signups: '신규 가입',
    admin_period_7d: '7일',
    admin_period_14d: '14일',
    admin_period_30d: '30일',
};

/**
 * 관리자 언어 토글 헬퍼
 * - getAdminLang(): localStorage에서 현재 설정 언어 반환 ('ru' | 'ko')
 * - setAdminLang(): localStorage에 언어 저장
 * - getAdminT(): 현재 언어에 맞는 번역 객체 반환 (KO는 admin_ 키만, 나머지는 RU fallback)
 */
export function getAdminLang(): string {
    if (typeof localStorage !== 'undefined') {
        return localStorage.getItem('admin-lang') || 'ru';
    }
    return 'ru';
}

export function setAdminLang(lang: string): void {
    if (typeof localStorage !== 'undefined') {
        localStorage.setItem('admin-lang', lang);
    }
}

export function getAdminT(): Record<string, string> {
    const lang = getAdminLang();
    if (lang === 'ko') {
        return new Proxy(RU as any, {
            get(target: any, prop: string) {
                if (prop in KO) return KO[prop];
                return target[prop] || prop;
            }
        });
    }
    return RU as any;
}

export function t(key: I18nKey): string {
    return RU[key] || key;
}
